import { render, staticRenderFns } from "./TrialTest.vue?vue&type=template&id=6c70254a"
import script from "./TrialTest.vue?vue&type=script&lang=js"
export * from "./TrialTest.vue?vue&type=script&lang=js"
import style0 from "./TrialTest.vue?vue&type=style&index=0&id=6c70254a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports